import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"notifications"},_vm._l((_vm.notifications),function(notification,index){return _c('div',{key:'notification-' + index,staticClass:"notification-wrapper"},[_c(VAlert,{staticClass:"notification",attrs:{"border":"left","dense":"","type":notification.type}},[_vm._v(_vm._s(notification.message))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }